import React from "react";
import styles from "./TrustReviews.module.css";

const points = [
  {
    id: "choose",
    title: "Why Choose Us?",
    description:
      "Best desert safari operator with certified drivers and top-rated experiences.",
  },
  {
    id: "cancel",
    title: "Free Cancellation",
    description:
      "For most excursions, cancel free of charge and get a full refund up to 24 hours before.",
  },
];

function TrustReviews() {
  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Trust &amp; Reviews</h2>

        <div className="row g-4 align-items-center">
          <div className="col-12 col-md-4">
            <div className={styles.googleBox}>
              <p className={styles.googleLogo}>
                <span className={styles.gBlue}>G</span>
                <span className={styles.gRed}>o</span>
                <span className={styles.gYellow}>o</span>
                <span className={styles.gBlue}>g</span>
                <span className={styles.gGreen}>l</span>
                <span className={styles.gRed}>e</span>
              </p>
              <p className={styles.googleRating}>5 stars 5 star</p>
              <p className={styles.stars} aria-label="5 out of 5 stars">
                ★★★★★
              </p>
            </div>
          </div>

          <div className="col-12 col-md-8">
            <div className="row g-3">
              {points.map((point) => (
                <div key={point.id} className="col-12 col-sm-6">
                  <div className={styles.pointCard}>
                    <span className={styles.checkIcon}>✔</span>
                    <p className={styles.pointTitle}>{point.title}</p>
                    <p className={styles.pointDescription}>
                      {point.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustReviews;
